<template>
  <div>
    <qua-form @handleSubmit="handleSubmit" :btnLoading="loading"/>
  </div>
</template>

<script>
import { Toast } from '@zz-common/zz-ui'
import { checkAuditStatusNew, submitBizLicense } from '../../../../api/resourceApi'
import QuaForm from '../../../common/QuaForm'

export default {
  name: 'QualityLicense',
  inject: ['$rootEle'],
  data() {
    return {
      loading: false
    }
  },
  components: {
    QuaForm
  },
  methods: {
    filesAdded(fileList) {
      console.log('added', fileList)
    },
    fileSuccess(file) {
      console.log('success', file)
    },
    async getDetial() {
      console.log('getDetial-before');
      const { permitStatus, hasLicense } = await checkAuditStatusNew({
        infoId: this.$rootEle.infoId,
        permitType: this.$rootEle.permitType,
        productQuaType: this.$rootEle.productQuaType
      }) //0未处理1成功2失败  hasLicence代表是否有营业执照
      console.log('getDetial', permitStatus);
      if (hasLicense == '0') {
        return ''
      } else {
        return this.$rootEle.stateChange('license', 'permit', 1)
      }
    },
    handleSubmit(params) {
      console.log('handleSubmit', params);
      const newParams = { ...params, sourceCode: this.$rootEle.sourceCode }
      this.loading = true;
      submitBizLicense(newParams)
        .then((_res) => {
          this.loading = false
          Toast('提交成功')
          this.$rootEle.stateChange('license', 'permit', 1)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    }
  },
  mounted() {
    this.getDetial()
  }
}
</script>

<style lang="less" scoped>
</style>
